import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

// Critical page: NOT lazy loaded (main entry point)
import { HomePage } from './pages';

// Lazy load all other pages
const CasesPage = lazy(() =>
  import('./pages/CasesPage').then((m) => ({ default: m.CasesPage }))
);
const CaseDetailPage = lazy(() =>
  import('./pages/CaseDetailPage/CaseDetailPage').then((m) => ({
    default: m.CaseDetailPage,
  }))
);
const CasePreviewPage = lazy(() =>
  import('./pages/CasePreviewPage/CasePreviewPage').then((m) => ({
    default: m.CasePreviewPage,
  }))
);
const ContactPage = lazy(() =>
  import('./pages/ContactPage').then((m) => ({ default: m.ContactPage }))
);
const NotFoundPage = lazy(() =>
  import('./pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage }))
);

const LEGACY_SITE_URL = 'https://codex.lnr.agency/';

const ExternalRedirect = ({ to }: { to: string }) => {
  window.location.href = to;
  return null;
};

/**
 * Page loading fallback
 */
const PageLoader = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '50vh',
    }}
  >
    <div
      style={{
        width: 40,
        height: 40,
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #333',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    />
    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
  </div>
);

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/cases"
        element={
          <Suspense fallback={<PageLoader />}>
            <CasesPage />
          </Suspense>
        }
      />
      <Route
        path="/cases/preview/:token"
        element={
          <Suspense fallback={<PageLoader />}>
            <CasePreviewPage />
          </Suspense>
        }
      />
      <Route
        path="/cases/:slug"
        element={
          <Suspense fallback={<PageLoader />}>
            <CaseDetailPage />
          </Suspense>
        }
      />
      <Route
        path="/codex"
        element={<ExternalRedirect to={LEGACY_SITE_URL} />}
      />
      <Route
        path="/contact"
        element={
          <Suspense fallback={<PageLoader />}>
            <ContactPage />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<PageLoader />}>
            <NotFoundPage />
          </Suspense>
        }
      />
    </Routes>
  );
};
